export const environmentVariables = {
    VUE_APP_API_VERSION: "/api/v2",
    APP_INSIGHTS_INSTRUMENTATION_KEY: "2da1773a-cdf0-4198-99b4-921d8a02a386",
};
